import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Page from './Page.tsx';
import Map from './map/Map.tsx';
import Backend from './backend/Backend.tsx';

export const routes = [
  {
    path: '/',
    menuLabel: 'Home',
    menuUrl: '/',
    element: (
      <Page>
        <Map />
      </Page>
    ),
  },
  {
    path: '/imprint',
    menuLabel: 'Impressum',
    menuUrl: '/imprint',
    element: (
      <Page>
        <h1>About</h1>
      </Page>
    ),
  },
  {
    path: '/backend',
    menuLabel: 'Backend',
    menuUrl: '/backend',
    element: (
      <Page>
        <Backend />
      </Page>
    ),
  },
];
const router = createBrowserRouter(routes);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
